<template>
<aside>
  <ul>

    <Profile/>

    <div @click="sidebarClicked">
      <router-link tag="a" to="/campaigns">
        <svgicon name="campaign" color="white" scale="1.5"></svgicon>
        <span>{{ $t('sidebar.campaigns') }}</span>
      </router-link>
    </div>

    <div @click="sidebarClicked">
      <router-link tag="a" to="/cockpit">
        <svgicon name="cockpit" color="white" scale="1.5"></svgicon>
        <span>{{ $t('sidebar.cockpit') }}</span>
      </router-link>
    </div>
  </ul>

</aside>
</template>

<script>
import {
  mapMutations
} from 'vuex'

import Profile from './Profile'
import Flags from './Flags'

export default {
  components: {
    Profile, Flags
  },
  methods: {
    ...mapMutations(['toggleMenu']),
    sidebarClicked (e) {
      if (window.innerWidth < 768) {
        this.toggleMenu()
      }
    }
  }
}
</script>

<style scoped lang="stylus" src="../../styles/_Sidebar.styl"/>



// WEBPACK FOOTER //
// src/components/common/Sidebar.vue